/**
 * SPB Analytics Dashboard Plugin — entry point and registration.
 *
 * Exports the spbAnalyticsDashboard plugin implementing DashboardPlugin.
 * This is the first plugin in the dashboard framework.
 */

import React from "react";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import type { DashboardPlugin } from "../../types";
import SPBFilterPanel from "./SPBFilterPanel";
import SPBReportContent from "./SPBReportContent";
import { useSPBAnalyticsData } from "./useSPBAnalyticsData";
import { buildSPBPrompts } from "./promptBuilder";
import { exportTableDataToCsv } from "../../utils/csvExport";

export const spbAnalyticsDashboard: DashboardPlugin = {
  id: "spb-analytics",
  displayName: "FINN Revenue Bridging Dashboard",
  icon: React.createElement(ShowChartIcon),
  description: "Sponsored Products & Brands performance analytics",

  FilterPanel: SPBFilterPanel,
  ReportContent: SPBReportContent,
  useData: useSPBAnalyticsData,

  aiSummary: {
    enabled: true,
    promptBuilder: buildSPBPrompts,
  },

  supportsComparison: true,

  exportCsv: (data: any, comparisonData?: any) => {
    if (data?.reportData?.metricsTable) {
      return exportTableDataToCsv(
        data.reportData.metricsTable,
        comparisonData?.reportData?.metricsTable
      );
    }
    return "";
  },
};
